import React, { Component } from 'react'
import { Tabs, Row, Col, Form, Input, Tag, Button, Spin, Icon, Tooltip, Progress, notification } from 'antd';
import TopNav from '../../components/topnav/topnav';
import Footer from '../../components/footer/footer';
// import PostFormEdit from '../../components/postedit/postformedit'
import { connect } from 'react-redux';
import {bindActionCreators} from "redux"
import PostCatUploadEdit from '../../components/postedit/postcatuploadedit'
const TabPane = Tabs.TabPane;
const openNotificationWithIcon = (type, msg, desc) => {
  notification[type]({
    message: msg,
    description: desc,
  });
};
class PostEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tabStyle: 'left',
      slug: ''
    };
  }

  componentWillMount() {
    const { slug } = this.props.match.params;
    this.setState({
      slug
    })
    const role = localStorage.getItem('role');
    if (role !== 'admin') {
      this.props.history.goBack();
    }
    this.switchTabStyle()
  }

  switchTabStyle = () => {
    let size = window.innerWidth
    if(size <= 415) {
      this.setState({
        tabStyle: 'top'
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    const {post} = nextProps
    if(post.editCatSuccess) {
      openNotificationWithIcon('success', 'Post Category Edited!', post.editCatSuccess)
      post.editCatSuccess = null
      this.props.history.push('/settings')
    }
    if(post.editCatError) {
      openNotificationWithIcon('error', 'Post Category Edit Failed!', post.editCatError)
      post.editCatError = null
    }
  }

  render() {
    const { tabStyle, slug } = this.state
    return (
      <div className="postedit">
        <TopNav history={this.props.history} />
        <section className="postedit-main">
        <Tabs size="large" defaultActiveKey="1" tabPosition={tabStyle}>
            <TabPane tab="Edit post category" key="1">
              <Row>
                <Col lg={16} sm={24}>
                  <PostCatUploadEdit slug={slug}/>
                </Col>
              </Row>
            </TabPane>
          </Tabs>
        </section>
        <Footer/>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  post: state.post
})

const mapDispatchToProps = dispatch => bindActionCreators({
},dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PostEdit);